module.exports = __webpack_public_path__ + "static/media/order_ride.51a3456f.svg";